// Posted by the embedded flow to its parent on close; listened for by its host.
export const FLOW_CLOSE_MESSAGE = "light-flow-close";
